/// <reference types="vite/client" />
import { loadArticles, type HelpArticle, type HelpAudience } from './articles';

// Every `articles/<audience>/<slug>.md` as raw text, bundled at build time by
// Vite (the same glob runs under vitest). Adding an article is adding the file.
const files = import.meta.glob('./articles/*/*.md', {
  query: '?raw',
  import: 'default',
  eager: true,
}) as Record<string, string>;

const loaded = loadArticles(files);

if (import.meta.env.DEV && loaded.problems.length > 0) {
  // The tests fail on these; in dev they also show in the console.
  console.warn(`Help articles with problems:\n${loaded.problems.join('\n')}`);
}

/** Every valid article, across audiences. */
export const ALL_ARTICLES: readonly HelpArticle[] = loaded.articles;

/** Problems found while loading, each prefixed with its file (tests require none). */
export const ARTICLE_PROBLEMS: readonly string[] = loaded.problems;

const BY_ID = new Map(ALL_ARTICLES.map((a) => [a.id, a]));

export function getArticle(id: string): HelpArticle | undefined {
  return BY_ID.get(id);
}

export function articlesFor(audience: HelpAudience): HelpArticle[] {
  return ALL_ARTICLES.filter((a) => a.audience === audience);
}
